<template>
  <b-container>
  </b-container>
</template>
<script>
// Es el redirect_uri registrado en la app de Mercado Libre (platforms.hookUrl): el callback
// de OAuth de la v2 entra por acá y se reenvía con la query intacta.
export default {
  name: 'MercadolibreIntegrationPage',
  beforeMount() {
    if (!this.$route.query.code) {
      this.$router.push({ name: 'search' })
      return
    }
    this.$router.push({ name: 'profile-meli-v2-integrations', query: this.$route.query })
  }
}
</script>
